
import { MapsAPILoader } from '@agm/core';
import {  Component, ElementRef, OnInit } from '@angular/core';
import { ViewChild, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from '@angular/router';
import { DatatableComponent, ColumnMode } from "@swimlane/ngx-datatable";
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'app/App Store/state';
import { setPageNumber } from 'app/App Store/actions/pageChange.actions';

@Component({
  selector: 'app-student-lms-report',
  templateUrl: './student-lms-report.component.html',
  styleUrls: ['./student-lms-report.component.scss',"../../../../../../assets/sass/libs/datatables.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class StudentLmsReportComponent implements OnInit {

  @ViewChild(DatatableComponent) table: DatatableComponent;
  @ViewChild("search")
  public searchElementRef: ElementRef;

  page = {
    pageNumber: 0,
    offset: 0,
    pageSize: 20,
    totalPages: 0
  };
  // row data
  public rows = [];
  public filterRows = [];
  public ColumnMode = ColumnMode;
  public limitRef = 20;
  selectedValue = ''
  activeTab: any = 'Classroom';
  isFilter: boolean = false
  searchByName=''
  searchVal:any
  public columns = [
    { name: "Student", prop: "student" },
    { name: "Course", prop: "course" },
    { name: "DOJ", prop: "doj" },
    { name: "Status", prop: "status" },
  ];

  imageUrl = environment.apiUrls.imageUrl;
  userId:any;
  enrolementStatus:any
  enrol_pending_data:any=[]
  @ViewChild('name') inputName;
  user_role:any
  performer_event=null
  performer_list=[
    {id:'yes', name:'Yes'},
    {id:'no', name:'No'},
  ]
  student_id:any
  placement_data:any
  businessTypeCompany_Id='6325ce10bc4b543c7a2429ad'
  selectedCollege=null
  collegeList=[]
  address: string;
  latitude: number;
  longitude: number;
  zoom: number;
  placement_model={
    address:'',
    linkedIn:'',
    bio:'',
    placementinfo:'',
    placement_business:''
  }
  formData=new FormData()
  fileData:File;
  imgUrl:any;
  key_Values=[]
  sprint_id:any
  sprint_data_id:any

  guideline_data:any

  enrollment_status=[
    {name:'Classroom' , _id:'classroom'},
    {name:'Online' , _id:'online'}
    ]
  learningModeId='631ad8abce5c666542591bd9'

  next_action_model={
    next_action:'',
    last_activedate:'',
    lastresponse:'',
    notes:''
  }
  next_action_name:any
  nextaction_tagcat_id = '63e39b572052e0098e18dfc2'
  nextactionList = []
  emp_List=[];
  typeId=  "6344000d91f6bc691e775faf" 
  selected_emp_referral = null
  row_id:any
  user_type:any
  empType:any=[]
  referral_model ={
    refrence: '',
    report_to: '',
    notes: '',
    admin_notes: '',
  }
  emp_list =[]
  row_name :any
  user_idd:any
  form_data = new FormData()
  isRefral:any= true
  modalFor=''
  selected_mentor_buddy :string[]=[]
  project_list =[]
  selected_project=null
  project_cat_id = "644a5c10af0db342c32eeada"
  position_tagcat_id ="65aa77c7b4693efe6b224179"
  positionsIags_list =[]
  activePage=1
  pageNumberSubscription : Subscription
  pageNo
  batch_list = []
  teacher_list:any = []
  selected_teacherId:any = ''
  select_batch = null
  constructor(public apiService: ApiService,
    public toastr: ToastrService,
    private activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,private mapsAPILoader: MapsAPILoader,
    private route: Router,
    private store: Store<AppState>) {
        this.user_role=JSON.parse(localStorage.getItem('user'))

    this.activatedRoute.queryParams
      .subscribe((params: any) => {
        this.activeTab = params['status'];
        this.pageNo = +params['page'];
        if(this.pageNo>0){
          this.setPage(this.pageNo);
        }
        else this.page.pageNumber = this.pageNo?this.pageNo-1:0
      })
      this.pageNumberSubscription = this.store.select(state => state.page.pageNumber)
      .subscribe(pageNumber => {
        this.page.pageNumber = pageNumber;
        if(pageNumber !==undefined){
          this.page.pageNumber = pageNumber ?  pageNumber-1 :0
        }
      });
      this.getEmployeeList()
    let setting_data = JSON.parse(localStorage.getItem('setting-record'))
    let key_data = setting_data.filter((item) => item.key === 'Enrolments') 
    this.guideline_data = key_data[0]?._id
  }
  ngOnInit() {
  }
  setPage(pageNumber: number) {
    this.store.dispatch(setPageNumber({ pageNumber }));
  }

  pageChangeData(page,teacherObject) {
    const teacherId = teacherObject._id?teacherObject._id:teacherObject?.id;
    this.route.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { page: page.offset +1 },
      queryParamsHandling: 'merge' // keep existing query params
    });
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
      this.activePage = page.offset +1
      this.apiService.studentsGetByTeacher(teacherId,this.activeTab, page.offset +1, this.limitRef).subscribe((res: any) => {
          this.spinner.hide();
          this.setPage( page.offset +1)
          this.rows = res?.data?.items
          this.page.totalPages = res?.data?.totalCount
      })
  }

   enrollmentByMode(status,teacherId){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
            this.apiService.studentsGetByTeacher(teacherId,this.activeTab,this.page.pageNumber+1, this.limitRef).subscribe((res: any) => {
          if(res.statusCode === 200){
            this.spinner.hide();
            this.rows = res?.data?.items
            this.page.totalPages = res?.data?.totalCount
          }
        })
     
  }
  // =========================================== change enrollement tabs =========================================================
  activeEnrollmentTab(tab_name,page) {
    if(page<1){ page =1}
      const activetab = tab_name;
      if (activetab !== '') {
        this.route.navigate(
          [],
          { relativeTo: this.activatedRoute, queryParams: { status: activetab ,  page : page },queryParamsHandling: 'merge' }
        );
      }
  }
  // =========================================== programs type Tab =========================================================
    setAndGetEnrollmentsbyStatus() {
    this.activatedRoute.queryParams
      .subscribe((params: any) => {
        this.activeTab = params?.status;
        const teacherId = this.selected_teacherId?._id?this.selected_teacherId._id:this.selected_teacherId?.id
      this.enrollmentByMode(this.activeTab,teacherId)
      })
  }
   getEmployeeList() {
    this.apiService.getEmployeeList(1, 100).subscribe((res: any) => {
      this.teacher_list = res.items;
      this.empType = this.user_role.roles.includes('admin') ? '' : this.user_role.employeetype.map(item=>item.displayname)
      if (this.empType.includes('Teacher')){
        this.selected_teacherId = this.user_role
        if(this.activeTab ==='Classroom'){
          this.activeEnrollmentTab(this.activeTab,this.pageNo?this.pageNo:1)
        }
        if(this.activeTab ==='Online'){
          this.activeEnrollmentTab(this.activeTab,this.pageNo?this.pageNo:1)
        }
        if(!this.activeTab) this.activeEnrollmentTab('Classroom',this.pageNo?this.pageNo:1)
      }else{
        this.selected_teacherId = this.teacher_list[0]
        if(this.activeTab ==='Classroom'){
          this.activeEnrollmentTab(this.activeTab,this.pageNo?this.pageNo:1)
        }
        if(this.activeTab ==='Online'){
          this.activeEnrollmentTab(this.activeTab,this.pageNo?this.pageNo:1)
        }
        if(!this.activeTab) this.activeEnrollmentTab('Classroom',this.pageNo?this.pageNo:1)
       }
      const teacherId = this.selected_teacherId?._id?this.selected_teacherId._id:this.selected_teacherId?.id
       this.apiService.studentsGetByTeacher(teacherId,status,this.page.pageNumber+1, this.limitRef).subscribe((res: any) => {
    if(res.statusCode === 200){
      this.spinner.hide();
      this.rows = res?.data?.items
      this.page.totalPages = res?.data?.totalCount
    }
  })
    })
  }  
    getStatusColor(status: string): string {
      switch (status) {
        case 'completed':
          return 'green';
        case 'left':
          return 'gray';
        case 'cancel':
          return 'red';
        case 'pending':
          return 'orange';
        case 'enrolled':
          return 'blue';
        default:
          return 'black';
      }
    }
    changeTeacherId(id){
      this.selected_teacherId = id
      this.setAndGetEnrollmentsbyStatus()
    }
}




